import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UiSwitchModule } from 'ngx-ui-switch';
import { Sidebar2FormMyProfileComponent } from './sidebar.2/sidebar2-form-myprofile.component';
import { Sidebar2IntegrationsActiveComponent } from './sidebar.2/sidebar2-integrations-active.component';
import { Sidebar2MenulockAngularComponent } from './sidebar.2/sidebar2-menulock-angular/sidebar2-menulock-angular.component';
import { Sidebar2OptionComponent } from './sidebar.2/sidebar2-option.component';
import { Sidebar2SubpanelCataloguesComponent } from './sidebar.2/sidebar2-subpanel-catalogues/sidebar2-subpanel-catalogues.component';
import { Sidebar2SubpanelIntegrationsComponent } from './sidebar.2/sidebar2-subpanel-integrations/sidebar2-subpanel-integrations.component';
import { Sidebar2SubpanelTenantComponent } from './sidebar.2/sidebar2-subpanel-tenants/sidebar2-subpanel-tenant.component';
import { Sidebar2SubpanelTenantsComponent } from './sidebar.2/sidebar2-subpanel-tenants/sidebar2-subpanel-tenants.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [CommonModule, FormsModule, UiSwitchModule, TranslateModule, NgScrollbarModule, RouterModule],
    declarations: [
        Sidebar2SubpanelTenantComponent,
        Sidebar2SubpanelCataloguesComponent,
        Sidebar2SubpanelTenantsComponent,
        Sidebar2OptionComponent,
        Sidebar2FormMyProfileComponent,
        Sidebar2SubpanelIntegrationsComponent,
        Sidebar2IntegrationsActiveComponent,
        Sidebar2MenulockAngularComponent,
    ],
    exports: [
        Sidebar2SubpanelTenantComponent,
        Sidebar2SubpanelCataloguesComponent,
        Sidebar2SubpanelTenantsComponent,
        Sidebar2OptionComponent,
        Sidebar2FormMyProfileComponent,
        Sidebar2SubpanelIntegrationsComponent,
        Sidebar2IntegrationsActiveComponent,
        Sidebar2MenulockAngularComponent,
    ],
})
export class LayoutModule {}
